import { Component } from 'react';
import WistiaPlayer from './WistiaPlayer';

const videoList = ['0scy8xvzx8', 'qsvkazcowb', 'spsmw3mmyg'];
class WistiaTests extends Component {
  state = { index: 0 };

  render() {
    return (
      <div>
        <WistiaPlayer
          autoPlay
          key="1"
          videoHash={videoList[this.state.index]}
          thumbnailUrl="https://embed-ssl.wistia.com/deliveries/5386d3df457a610acb0620cb778df4d479c85c15.jpg?image_crop_resized=640x360&foo"
        />
        <WistiaPlayer
          introWistiaHash="k5oqkvc6o2"
          autoPlay
          key="2"
          videoHash={videoList[this.state.index]}
          thumbnailUrl="https://embed-ssl.wistia.com/deliveries/5386d3df457a610acb0620cb778df4d479c85c15.jpg?image_crop_resized=640x360&foo"
        />
        <h1>{videoList[this.state.index]}</h1>
        <button
          onClick={() => {
            const next =
              this.state.index == videoList.length ? 0 : this.state.index + 1;
            this.setState({
              index: next,
            });
          }}
        >
          next
        </button>
        <button
          onClick={() => {
            const prev =
              this.state.index == 0
                ? videoList.length - 1
                : this.state.index - 1;
            this.setState({
              index: prev,
            });
          }}
        >
          prev
        </button>
      </div>
    );
  }
}
/*
 */
export default WistiaTests;
